import axios from "axios";
import { signalFromXhr } from "./ContractsPendingSignal";

// Local development: `npm start` reads REACT_APP_API_URL from .env.development.local (gitignored)
// and talks to the local backend. `npm run build` never reads that file, so deploys always use
// production.
export const baseURL = process.env.REACT_APP_API_URL || "https://api.cus-pro.com/";
// export const baseURL = "https://cu-e544a85462e84eaa8e7045233d0f44a6.ecs.eu-central-1.on.aws/";
// export const baseURL = "https://api2.cus-pro.com/";

// S3 URL for static files (images, documents, etc.)
export const cloudFrontURL = "https://cus-pro-files.s3.eu-central-1.amazonaws.com/";

export const BaseApiUrl = baseURL + "api/";

export const postAsync = async (url, data, afterCallback, token) => {
  makeRequest("post", BaseApiUrl + url, null, data, afterCallback, token);
};

export const getAsync = async (url, param, afterCallback, token) => {
  makeRequest("get", BaseApiUrl + url, param, null, afterCallback, token);
};

const makeRequest = async (method, url, param, data, afterCallback, token, sAlert, eAlert) => {
  let response = null;
  try {
    response = await axios({
      method,
      url,
      data: data,
      params: param,
      // "Content-Type": "multipart/form-data",
      // enctype: "multipart/form-data",
      // responseType: "json",
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type",
      },
    });

    const isDebug = window.isDebug || false;

    // Custom message alerts based on response status and debug mode
    if (isDebug || (response.data.statusCode === 0 && eAlert)) {
      alert(
        `BusinessStatus => ${response.data.statusCode}\n` +
          `BusinessMessage => ${response.data.message}\n` +
          `URL => ${url}\n` +
          `HTTP Status => ${response.status}`
      );
    } else if (response.data.statusCode === 1 && sAlert) {
      alert(`${response.data.message}\nURL => ${url}`);
    }

    // Log debug info to the console for additional traceability
    if (isDebug) {
      console.log("Debug Info:", {
        url,
        responseStatus: response.status,
        businessStatus: response.data.statusCode,
        businessMessage: response.data.message,
        responseData: response.data,
      });
    } //TODO SET This TO sAlert

    if (afterCallback) afterCallback(response);
  } catch (err) {
    if (window.isDebug) {
      console.log(err);
      alert(err.response?.status + "- Hata --> " + url + " // " + err.name + " - " + err.message);
    }

    const httpStatus = err.response?.status;
    const isAuthEndpoint = /User\/(Login|Register|googleOAuth|HashLogin|passwordresend|confirmemail)/i.test(url);

    // Session expired / token rejected on a protected endpoint -> force re-login.
    // Skip for auth endpoints, where a 401 just means bad credentials.
    if (httpStatus === 401 && !isAuthEndpoint) {
      localStorage.clear();
      window.location.reload(true);
      return;
    }

    // Business error (4xx/5xx) now carries a real HTTP status. Pass the error
    // response to the callback so callers can branch on status/message exactly
    // like a success response ({ status, data: { statusCode, data, message } }).
    if (afterCallback) afterCallback(err.response ?? { status: 0, data: null });
  }
};

const xmlPostFormData = async (url, formData, token, callback, errorCallback) => {
  const request = new XMLHttpRequest();
  request.open("POST", BaseApiUrl + url);
  request.onreadystatechange = function () {
    if (this.readyState === 4) {
      signalFromXhr(this);
      if (this.status === 200) {
        if (callback) callback(this);
      } else {
        console.error("XMLHttpRequest error:", this.status, this.statusText);
        if (errorCallback) {
          errorCallback(this);
        } else if (callback) {
          // Call the callback with error info so it can handle it
          callback(this);
        }
      }
    }
  };
  request.onerror = function () {
    console.error("XMLHttpRequest network error");
    if (errorCallback) errorCallback(this);
  };
  request.setRequestHeader("Authorization", `Bearer ${token}`);
  request.send(formData);
};

const ApiHelper = {
  postAsync,
  getAsync,
  xmlPostFormData,
  baseURL,
  cloudFrontURL,
};

export default ApiHelper;
